import * as React from 'react'
import { Theme } from '@mui/material/styles'
import { RequestStatus } from '@sales-center/common'
import Box from '@mui/material/Box'
import { useData } from './hooks/useData'
import { SectionHeading } from './styled/SectionHeading.styled'
import { ENTITY_TYPES } from '@sales-center/common'
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { useMapViewFeatureEnabled } from '@user/store/tenantFeatures/hooks/useMapViewFeatureEnabled'
import { useD2DKnockEnabled } from '@user/store/tenantFeatures/hooks/useD2DKnockEnabled'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  requestStatus: RequestStatus
}

export function ActivityHistoryFilterForm(props: Props) {
  const { onChange, requestStatus } = props
  const { filters } = useData()

  const mapViewEnabled = useMapViewFeatureEnabled()
  const knockStatusEnabled = useD2DKnockEnabled()

  return requestStatus !== 'idle' ? (
    <CircularProgress />
  ) : (
    <Box>
      <SectionHeading>Status Updates</SectionHeading>
      <Stack>
        <FormGroup sx={{ ml: 1 }}>
          {filters.statusUpdates.filters.map((f, index) => {
            if (
              f.name === 'Knock Status Update' &&
              !(mapViewEnabled && knockStatusEnabled)
            ) {
              return null
            }
            return props.entityType == ENTITY_TYPES.Lead ||
              props.entityType == ENTITY_TYPES.Opportunity ? (
              <FormControlLabel
                data-test-id={`activityTimelineHistoryStatusUpdates-${f.name}-checkbox`}
                control={
                  <Checkbox
                    checked={f.isSelected}
                    onChange={onChange}
                    sx={{
                      ml: 1,
                      padding: (theme: Theme) => theme.spacing(0.4),
                    }}
                    value={`statusUpdates|${f.name}`}
                  />
                }
                key={index}
                label={f.name}
              />
            ) : (
              ''
            )
          })}
        </FormGroup>
        <SectionHeading>Closing Activities</SectionHeading>
        <FormGroup sx={{ ml: 1 }}>
          {filters.closingActivities.filters.map((f, index) => (
            <FormControlLabel
              data-test-id={`activityTimelineHistoryClosingActivities-${f.name}-checkbox`}
              control={
                <Checkbox
                  checked={f.isSelected}
                  onChange={onChange}
                  sx={{ ml: 1, padding: (theme: Theme) => theme.spacing(0.4) }}
                  value={`closingActivities|${f.name}`}
                />
              }
              key={index}
              label={f.name}
            />
          ))}
        </FormGroup>
        <SectionHeading>Custom Activities</SectionHeading>
        <FormGroup sx={{ ml: 1 }}>
          {filters.customActivities.filters.map((f, index) => (
            <FormControlLabel
              data-test-id={`activityTimelineHistoryCustomActivities-${f.name}-checkbox`}
              control={
                <Checkbox
                  checked={f.isSelected}
                  inputProps={{
                    name: `Custom Activities|${f.name}`,
                  }}
                  onChange={onChange}
                  sx={{ ml: 1, padding: (theme: Theme) => theme.spacing(0.4) }}
                  value={f.id}
                />
              }
              key={index}
              label={f.name}
            />
          ))}
        </FormGroup>
      </Stack>
    </Box>
  )
}
